import { TableColumn, utils, Badge } from "@vilocnv/allsetra-core";
import { DriverMileageDto } from "../entities/dtos/driver-mileage.dto";
import { MileageIcon } from "assets/icons";

export const DRIVER_MILEAGE_TABLE_COLUMNS = (
  translator: any,
  data?: DriverMileageDto[]
): TableColumn<DriverMileageDto>[] => [
  {
    name: "№",
    selector: (row: DriverMileageDto, index?: number) => {
      return index !== undefined ? index + 1 : "";
    },
    sortable: false,
    width: "60px"
  },
  {
    name: translator("tableHeading.driverName", {
      ns: "tableHeadingsTranslation"
    }),
    selector: (row: DriverMileageDto) => {
      const firstName = row.driver?.firstName || "";
      const lastName = row.driver?.lastName || "";
      return `${firstName} ${lastName}`.trim() || "-";
    },
    sortable: true,
    sortField: "driver.firstName"
  },
  {
    name: translator("tableHeading.driverEmail", {
      ns: "tableHeadingsTranslation"
    }),
    selector: (row: DriverMileageDto) => row.driver?.email || "-",
    sortable: true,
    sortField: "driver.email"
  },
  {
    name: translator("tableHeading.year", {
      ns: "tableHeadingsTranslation"
    }),
    selector: (row: DriverMileageDto) => row.year || "-",
    sortable: true,
    sortField: "year",
    width: "100px"
  },
  {
    name: translator("tableHeading.totalMileage", {
      ns: "tableHeadingsTranslation"
    }),
    cell: (row: DriverMileageDto) =>
      row?.totalKilometers !== undefined && row?.totalKilometers !== null ? (
        <Badge
          colorScheme={"info"}
          icon={<MileageIcon />}
          textVariant={"small"}
        >
          {row?.totalKilometers?.toFixed(1)} km
        </Badge>
      ) : (
        "N/A"
      ),
    sortable: true,
    sortField: "totalKilometers"
  },
  {
    name: translator("tableHeading.lastNotificated", {
      ns: "tableHeadingsTranslation"
    }),
    selector: (row: DriverMileageDto) =>
      row.lastNotificated
        ? utils.formatDate({ date: row.lastNotificated })
        : "N/A",
    sortable: true,
    sortField: "lastNotificated"
  }
];
